import { Form } from '@unform/web';
import styled from 'styled-components';

import { breakpoints } from '~/styles/tools/breakpoints';

export const EditUserForm = styled(Form)`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2.4rem;

  @media (max-width: ${breakpoints.medium}) {
    display: flex;
    flex-direction: column;
  }
`;

export const EditUserInputBlock = styled.label`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  > p {
    font-size: 1.4rem;
    opacity: 0.65;
    color: ${({ theme }) => theme.colors.black};
    user-select: none;
    padding: 0 0 0.6rem 1.2rem;
  }
`;

export const EditUserBoxImageLabel = styled.label`
  display: block;
  margin-bottom: 0.8rem;

  &:hover {
    cursor: pointer;
  }
`;

export const EditUserBoxImage = styled.label`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 141px;
  height: 141px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.34);

  > img {
    max-width: 141px;
    max-height: 141px;
  }

  &:hover {
    cursor: pointer;
  }

  @media (max-width: ${breakpoints.medium}) {
    margin: 0 auto;
  }
`;
